export default {
  title: {
    create: 'สร้างข้อมูลบริการ',
    detail: 'รายละเอียดบริการ'
  },
  headers: {
    no: 'รหัสบริการ',
    name: 'ชื่อบริการ',
    category: 'หมวดหมู่',
    type: 'ประเภท',
    status: 'สถานะ',
    sale: 'การขาย'
  },
  label: {
    nameTh: 'ชื่อบริการ (TH)',
    nameEn: 'ชื่อบริการ (EN)',
    myCourse: 'บริการของฉัน',
    noCourseData: 'ไม่พบข้อมูลบริการ',
    getTreatmentServices: 'รับบริการรักษา/บริการ',
    create: 'สร้างบริการ',
    cutStock: 'ตัดสต็อก',
    cutStockList: 'รายการตัดสต็อกสินค้า',
    serviceTime: 'ระยะเวลาการบริการ',
    minute: 'นาที',
    noneTime: 'ไม่ต้องจับเวลาบริการ',
    showOnOpdPage: 'แสดงในหน้า OPD',
    hasStock: 'มีสต็อกสินค้า',
    hasDFCharge: 'มีรายการค่ามือ DF',
    dfChargeList: 'รายการค่ามือ DF',
    productAndFormulaList: 'รายการสินค้าและสูตรยา',
    dfChargeType: 'รูปแบบการคิดค่ามือ DF',
    additionalFromServiceCharge: 'คิดเพิ่มจากค่าบริการ',
    includedInServiceCharge: 'รวมในค่าบริการแล้ว',
    showMedicationFormulaInOpd: 'แสดงสูตรยาในหน้า OPD',
    showItemsInInvoice: 'แสดงรายการในใบชำระ',
    paymentProof: 'หลักฐานการชำระ.pdf',
    showQuantityInReceipt: 'แสดงจำนวนในใบรับชำระ',
    enterFeeByDoctor: 'กรอกค่ามือตามรายแพทย์',
    category: 'หมวดหมู่บริการ',
    categoryName: 'ชื่อหมวดหมู่บริการ',
    PDS: 'รายการสินค้า สูตรยาและบริการ'
  },
  placeholder: {
    searchName: 'ค้นหาชื่อบริการ',
    searchIdName: 'ค้นหารหัสบริการ ชื่อบริการ',
    enterId: 'กรอกรหัสบริการ',
    enterInfo: 'กรอกข้อมูลบริการ',
    nameTh: 'กรอกชื่อบริการ (TH)',
    nameEn: 'กรอกชื่อบริการ (EN)',
    cutStockList: 'เลือกรายการตัดสต็อกสินค้า',
    enterDF: 'กรอกรายการค่ามือ DF',
    serviceTime: 'กรอกระยะเวลาการบริการ',
    showOnOpdPage: 'แสดงในหน้า OPD',
    hasStock: 'มีสต็อกสินค้า',
    hasDFCharge: 'มีรายการค่ามือ DF',
    dfChargeList: 'รายการค่ามือ DF',
    productAndFormulaList: 'เลือกรายการสินค้าและสูตรยา',
    selectedLabelItems: 'เลือกรายการที่ให้แสดงบนฉลากยา',
    dfChargeType: 'รูปแบบการคิดค่ามือ DF',
    additionalFromServiceCharge: 'คิดเพิ่มจากค่าบริการ',
    includedInServiceCharge: 'รวมในค่าบริการแล้ว',
    enterFer: 'กรอกค่ามือ DF',
    category: 'กรอกข้อมูลหมวดหมู่บริการ',
    enterCategory: 'กรอกหมวดหมู่บริการ',
    searchCategory: 'ค้นหาชื่อหมวดหมู่บริการ'

  },
  toolTip: {
    create: 'สร้างบริการ',
    edit: 'แก้ไขบริการ',
    delete: 'ลบบริการ',
    view: 'ดูข้อมูลบริการ',
    searchIdName: 'ค้นหารหัสบริการ ชื่อบริการ'
  },
  modal: {
    create: {
      title: 'สร้างข้อมูลบริการ',
      success: 'สร้างบริการสำเร็จ',
      category: {
        success: 'เพิ่มหมวดหมู่บริการสำเร็จ'
      }
    },
    edit: {
      title: 'แก้ไขข้อมูลบริการ',
      success: 'แก้ไขบริการสำเร็จ',
      category: {
        success: 'แก้ไขหมวดหมู่บริการสำเร็จ'
      }
    },
    delete: {
      title: 'ลบบริการ',
      content1: 'คุณกำลังลบบริการ',
      content2: 'ต้องการดำเนินการต่อหรือไม่',
      confirm: 'ยืนยันการลบบริการ',
      cancel: 'ยกเลิก',
      success: 'ลบบริการสำเร็จ',
      category: {
        title: 'ยืนยันการลบหมวดหมู่บริการ',
        subTitle: 'คุณกำลังลบหมวดหมู่บริการ ต้องการดำเนินการต่อหรือไม่',
        success: 'ลบหมวดหมู่บริการสำเร็จ'

      }
    }
  }

}
